// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"334":"app-theme-dark1","522":"app-theme-dark0","554":"app-theme-light1","641":"app-theme-light0"}[chunkId] + "." + {"334":"1152feea","522":"611b70a5","554":"067235e2","641":"20e723c3"}[chunkId] + ".chunk.css";
};